<form [formGroup]="realEstateUopForm" class="realEstateProjectForm">
  <div formArrayName="uopDetails" class="formDiv">
    <div class="tableHeader">
      <span class="uopProject"> Unit of Property for Project </span>
      <span class="uopDescription"> Unit of Property Description </span>
      <span class="uopInstallMaterial"> Install Material </span>
      <span class="uopInstallLabor"> Install Labor </span>
      <span class="uopRemovalLabor"> Removal Labor </span>
      <span class="uopVintageYear"> Vintage Year / Useful Life </span>
    </div>
    <div
      *ngFor="let uop of uopDetails.controls; let i = index"
      [formGroupName]="i"
      class="tableBody"
    >
      <mat-form-field class="uopProject">
        <input matInput formControlName="uopProject" />
      </mat-form-field>
      <mat-form-field class="uopDescription">
        <mat-select formControlName="uopDesc" required>
          <!-- Search Input -->
          <mat-option>
            <input
              matInput
              placeholder="Search UOP Description"
              [formControl]="uopSearchControl"
              (input)="filterUopDesc(i)"
              (click)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()"
            />
          </mat-option>
          <!-- Filtered Options -->
          <mat-option
            *ngFor="let uop of filteredUopDescriptions[i]"
            [value]="uop.unit_of_property"
          >
            {{ uop.unit_of_property }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="uopInstallMaterial">
        <input
          matInput
          formControlName="uopInstallMaterial"
          appCurrencyMask
          appNumbersOnly
        />
        <span matPrefix>$</span>
      </mat-form-field>
      <mat-form-field class="uopInstallLabor">
        <input
          matInput
          formControlName="uopInstallLabor"
          appCurrencyMask
          appNumbersOnly
        />
        <span matPrefix>$</span>
      </mat-form-field>
      <mat-form-field class="uopRemovalLabor">
        <input
          matInput
          formControlName="uopRemovalLabor"
          appCurrencyMask
          appNumbersOnly
        />
        <span matPrefix>$</span>
      </mat-form-field>
      <mat-form-field class="uopVintageYear">
        <input
          matInput
          formControlName="uopVintageYear"
          placeholder="YYYY / LL"
          (input)="formatVintageYear($event, i)"
          maxlength="11"
        />
      </mat-form-field>
      <img
        *ngIf="!reviewMode"
        style="cursor: pointer; width: 1rem; height: 1rem; margin-left: auto"
        src="assets/trash-bin-base.svg"
        (click)="deleteUopOption(i)"
      />
    </div>
    <div class="tableFooter">
      <span class="uopAddButton" (click)="addUopOption()" *ngIf="!reviewMode">
        <span style="font-weight: bold; font-size: 1.4rem">&#43;</span>
        <span class="uopAddText"> Add Unit of Property </span>
      </span>
      <span style="padding-right: 2rem">
        Total: {{ getTotalUopCost() | currency : "USD" : "symbol" : "1.2-2" }}
      </span>
    </div>
  </div>
</form>
